//export const BASE_URL = 'http://localhost:5000';
export const BASE_URL = "https://jdpublicbackend.onrender.com";
//export const BASE_URL = 'https://jdpublicschools.in';
